var _defs, _rect, _path, _rect2, _polygon, _rect3, _polygon2, _polygon3, _circle, _circle2, _circle3, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaseStationBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Base",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 295.6 368.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bsb-cls-1{fill:url(#linear-gradient);}.bsb-cls-2{fill:url(#linear-gradient-2);}.bsb-cls-3{fill:url(#linear-gradient-3);}.bsb-cls-4{fill:url(#linear-gradient-4);}.bsb-cls-5{fill:url(#linear-gradient-5);}.bsb-cls-6{fill:url(#linear-gradient-6);}.bsb-cls-7{fill:url(#linear-gradient-7);}.bsb-cls-8{fill:url(#linear-gradient-8);}.bsb-cls-9{fill:url(#radial-gradient);}.bsb-cls-10{fill:url(#radial-gradient-2);}.bsb-cls-11{fill:none;stroke-miterlimit:10;stroke-width:2px;stroke:url(#radial-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 117.74,
    y1: 166.61,
    x2: 180,
    y2: 166.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#423f40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#454344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#504d4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#626061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7b797a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#989697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#918f90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#7d7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5d5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#313030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 816.29,
    y1: 700.99,
    x2: 1080.96,
    y2: 700.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1c1b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#323132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4f4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#717071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#989697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#636263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#1a1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 358.45,
    x2: 295.6,
    y2: 358.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#423f40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8b8889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9f9c9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dbd9da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f2f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#faf9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#adabac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#989697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#cfcece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a8a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#464545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0,
    y1: 344.13,
    x2: 295.6,
    y2: 344.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 96.59,
    y1: 258.68,
    x2: 203.36,
    y2: 258.68,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 96.59,
    y1: 286.39,
    x2: 203.36,
    y2: 286.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 96.59,
    y1: 230.82,
    x2: 203.36,
    y2: 230.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 98.53,
    y1: 50.34,
    x2: 199.21,
    y2: 50.34,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 148.87,
    cy: 50.34,
    r: 35.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#423f40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8b8889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9f9c9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dbd9da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f2f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#edeced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#cfcece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a8a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#464545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 148.87,
    cy: 49.73,
    r: 23.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#423f40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#403d3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#393738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2e2b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1d1b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 149.97,
    cy: 245.43,
    r: 37.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#423f40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#454344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#504d4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#626061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7b797a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#989697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#969495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8e8c8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#848283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#787677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#585556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4a4b"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Base") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bsb-cls-1",
    x: 117.74,
    y: 57.37,
    width: 62.25,
    height: 218.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bsb-cls-2",
    d: "M816.29,726.19s66.26-14.83,78.32-26.89a302.23,302.23,0,0,0,21.08-23.51h71.69s11.45,15.59,22.29,23.76S1081,726.19,1081,726.19Z",
    transform: "translate(-802.63 -386.08)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "bsb-cls-3",
    y: 348.14,
    width: 295.6,
    height: 20.62
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "bsb-cls-4",
    points: "0 348.14 13.65 340.11 278.33 340.11 295.6 348.14 0 348.14"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "bsb-cls-5",
    x: 96.59,
    y: 234.28,
    width: 106.77,
    height: 48.8
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "bsb-cls-6",
    points: "96.59 283.08 113.06 289.71 184.75 289.71 203.36 283.08 96.59 283.08"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "bsb-cls-7",
    points: "96.59 234.28 110.95 227.35 188.36 227.35 203.36 234.28 96.59 234.28"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "bsb-cls-8",
    cx: 148.87,
    cy: 50.34,
    r: 50.34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "bsb-cls-9",
    cx: 148.87,
    cy: 50.34,
    r: 35.21
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "bsb-cls-10",
    cx: 148.87,
    cy: 49.73,
    r: 23.44
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "bsb-cls-11",
    points: "96.59 242.11 120.49 242.11 127.11 248.74 140.97 248.74 146.79 242.92 203.36 242.92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseStationBase);
export default __webpack_public_path__ + "static/media/BaseStationBase.e9d50b40350e9c88b4f46513ceae3184.svg";
export { ForwardRef as ReactComponent };